import { createAsyncThunk } from "@reduxjs/toolkit"

import { errorSave } from "../../../redux/errors.slice"
import { unknownError } from "../../../utils/handlers/handle-error"
import { showResponseMessage } from "../../../utils/handlers/show-response-message.ts"
import * as services from "../api/services.ts"
import type { LeadNote, NoteCategory } from "../types/lead.types.ts"

export interface CreateLeadNoteThunkParams {
  leadId: string
  content: string
  category: NoteCategory
  is_pinned?: boolean
}

export const createLeadNote = createAsyncThunk<
  LeadNote,
  CreateLeadNoteThunkParams
>(
  "lead/createLeadNote",
  async ({ leadId, ...data }, { dispatch, rejectWithValue }) => {
    const response = await services.createLeadNote(leadId, data)

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details || unknownError))
      return rejectWithValue(response.data)
    }

    showResponseMessage(response, "Note added successfully.")

    return response!.data!.details.data
  }
)

export interface UpdateLeadNoteThunkParams {
  id: string
  content?: string
  category?: NoteCategory
  is_pinned?: boolean
}

export const updateLeadNote = createAsyncThunk<
  LeadNote,
  UpdateLeadNoteThunkParams
>(
  "lead/updateLeadNote",
  async ({ id, ...data }, { dispatch, rejectWithValue }) => {
    const response = await services.updateLeadNote(id, data)

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details || unknownError))
      return rejectWithValue(response.data)
    }

    showResponseMessage(response, "Note updated successfully.")

    return response!.data!.details.data
  }
)

export const deleteLeadNote = createAsyncThunk<string, string>(
  "lead/deleteLeadNote",
  async (id, { dispatch, rejectWithValue }) => {
    const response = await services.deleteLeadNote(id)

    if (!response.ok) {
      dispatch(errorSave(response?.data?.details || unknownError))
      return rejectWithValue(response.data)
    }

    showResponseMessage(response, "Note deleted successfully.")

    return id
  }
)
